import * as math from 'mathjs';

/**
 * Reset Mittelmenge/Dosis
 * @param abschnitt
 * @returns {*}
 */
window.herbizid_resetAbschnittData = function(abschnitt) {
  abschnitt.find('input.abschnitt-bruehmenge').val('');
  abschnitt.find('input.abschnitt-bruehmenge-intern').val('');
  abschnitt.find('.section-detail-mittel').remove();
};

/**
 * berechnungen summenzeile
 * @param summeAlt
 * @param alleAbschnitteId
 * @param abschnitte
 * @param savedBruehe
 * @returns {*&{bruehe: (number|*), mittel: {}}}
 */
window.herbizid_recalculateSumme = function(summeAlt, alleAbschnitteId, abschnitte, savedBruehe) {
  const flaeche = alleAbschnitteId.map(id => abschnitte[id]).reduce((a, b) => b.flaeche + a, 0);
  const behandelteFlaeche = alleAbschnitteId.map(id => abschnitte[id]).reduce((a, b) => b.herbizidflaeche + a, 0);

  let summeBrueheNeu;
  if (savedBruehe === true) {
    summeBrueheNeu = Number(summeAlt.bruehe);
  } else {
    summeBrueheNeu = roundBruehe(alleAbschnitteId.map(id => abschnitte[id]).reduce((a, b) => b.bruehe + a, 0.0));
  }

  const mittelNeu = {};
  if (summeAlt.alleMittelId.length > 0) {
    summeAlt.alleMittelId.forEach(mittelId => {
      const mittelmengeNeu = roundMittelmenge(
          alleAbschnitteId.map(id => abschnitte[id]).map(abschnitt => abschnitt.mittel[mittelId]).reduce((summe, m) => {
            return summe + m.mittelmenge;
          }, 0.0));

      const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu / flaeche * 10000);
      const mittelmengeProHaBehandelteFlaecheNeu = roundMittelmengeProHa(mittelmengeNeu / behandelteFlaeche * 10000);

      mittelNeu[mittelId] = {
        ...summeAlt.mittel[mittelId],
        mittelmenge: mittelmengeNeu,
        mittelmengeProHa: mittelmengeProHaNeu,
        mittelmengeProHaBehandelteFlaeche: mittelmengeProHaBehandelteFlaecheNeu,
      };
    });
  }

  return {
    ...summeAlt,
    bruehe: summeBrueheNeu,
    mittel: mittelNeu,
  };
};

/**
 * calculate Herbizidflaeche
 * @param abschnitt
 * @returns {number}
 */
window.herbizid_calculateFlaeche = function(abschnitt) {
  return abschnitt.herbizidflaecheProzent * abschnitt.flaeche / 100;
};

/**
 * calculate HerbizidBruehe
 * @param abschnitt
 * @param ausliterung
 * @returns {number}
 */
window.herbizid_calculateBruehe = function(abschnitt, ausliterung) {
  return ausliterung * herbizid_calculateFlaeche(abschnitt) / 10000;
};

/**
 * findDosisProHlBeiEingabeMittelmengeProBehandelteFlaeche
 * @param abschnitte
 * @param dosisProHaBehandelteFlaeche
 * @returns {undefined}
 */
window.findDosisProHlBeiEingabeMittelmengeProBehandelteFlaeche = function(abschnitte, dosisProHaBehandelteFlaeche) {
  let dosisMin = undefined;
  abschnitte.forEach(a => {
    const dosisProHl = a.herbizidflaeche * dosisProHaBehandelteFlaeche / a.bruehe / 10000;
    if (!dosisMin) {
      dosisMin = dosisProHl;
    } else {
      dosisMin = math.min(dosisMin, dosisProHl);
    }

  });
  return dosisMin;
};